"use client"

// import React from 'react'
// import { EmblaOptionsType } from 'embla-carousel'
// import Autoplay from 'embla-carousel-autoplay'
// import useEmblaCarousel from 'embla-carousel-react'

// export type CoolReview = {
//     content: string,
//     author: string,
// }

// export function CoolReviews(
//     {
//         slides,
//         className,
//         loop = true,
//     }: {
//         slides: CoolReview[]
//         loop?: boolean
//         className?: string
//     }
// ) {

//     const options: EmblaOptionsType = {
//         loop: loop,
// dragFree: true,
// align: 'start',
// breakpoints: {
// '(min-width: 768px)': { align: 'start' },
// },
//     }
//     const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay()])

//     return (
//         <section className={`embla ` + className}>
//             <div className="embla__viewport" ref={emblaRef}>
//                 <div className="embla__container">
//                     {slides.map((slide, index) => (
//                         <div className="embla__slide" key={`cr_${index}`}>
//                             <div className="embla__slide__number">
//                                 <p>{slide.content}</p>
//                                 <p>{slide.author}</p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default CoolReviews


import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay'
import { Heading } from '@medusajs/ui';

export type CoolReview = {
    content: string,
    author: string,
}

export function CoolReviews(
    {
        reviews,
        className,
        loop = true,
        autoPlay = false,
        locale
    }: {
        reviews: CoolReview[]
        loop?: boolean
        autoPlay?: boolean
        className?: string
        locale?: string
    }
) {
    const plugins = autoPlay ? [Autoplay()] : []
    const [emblaRef] = useEmblaCarousel({
        loop: true,
        dragFree: false,
        align: 'center',
        breakpoints: {
            '(min-width: 768px)': { align: 'center' },
        },
    }, plugins);
    return null
    if(reviews.length === 0){
        return null
    }

    return (
        <section className={`mx-auto py-8 px-8 max-w-[1400px] bg-white ${className}`}>
            <Heading className="my-6 text-center text-3xl font-bold">They says:</Heading>
            <div className="overflow-hidden" ref={emblaRef}>
                <div className="flex touch-pan-y touch-pinch-zoom -ml-4">
                    {reviews.map((slide, index) => (
                        <div
                            key={`cr_${index}`}
                            className="review-item flex-none w-full px-6"
                        >
                            <div className="flex flex-col p-10 mx-3 rounded-2xl bg-gray-50 text-center">
                                <p className="text-xl italic text-gray-700">"{slide.content}"</p>
                                <p className="mt-6 text-md font-semibold text-gray-500">- {slide.author}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CoolReviews;